import { useState } from 'react'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import { ItemType } from '../../../models/ViewModels/RecordCatalogViewModel'
import { RecordLaboratoryServeType } from '../../../models/ViewModels/RecordViewModel'
import { DatePicker, TextBox } from '../../../share/Elements'

const RecordLaboratoryResult = ({
  item,
  catalogs,
  onItemChange,
}: {
  catalogs?: Array<ItemType<number>>
  item?: RecordLaboratoryServeType
  onItemChange: (updatedItem: RecordLaboratoryServeType) => void // A function to handle item changes
}) => {
  const [date, setDate] = useState<string>(
    item?.resultDate
      ? new Date(item.resultDate).toDateString()
      : new Date().toDateString()
  )
  const handleToDateChange = (e) => {
    // Assuming you have a way to get the raytebValue
    const updatedItems = item?.items ? [...item.items] : []
    const dateInput = document.getElementById('ResultDate')
    const raytebValue = dateInput?.getAttribute('rayteb-value')
    const newToDate = new Date(raytebValue!)
    setDate(raytebValue!)
    onItemChange({
      ...item,
      items: updatedItems,
      resultDate: raytebValue == null ? new Date().toISOString() : raytebValue,
    })
  }
  const onChange = (event: React.ChangeEvent<HTMLSelectElement>, catalog) => {
    debugger
    // Create a copy of the items array (if it exists)
    const updatedItems = item?.items ? [...item.items] : []

    // Find the index of the item with a matching laboratoryServeId
    const itemIndex = updatedItems.findIndex(
      (obj) => obj.laboratoryServeId === catalog.id
    )

    if (itemIndex !== -1) {
      // If the item exists, update its description
      updatedItems[itemIndex].description = event.target.value
    } else {
      // If the item doesn't exist, create a new item and add it to the array
      updatedItems.push({
        laboratoryServeId: catalog.id,
        description: event.target.value,
      })
    }

    // Call the onItemChange function with the updated item
    onItemChange({
      ...item,
      items: updatedItems,
      resultDate: date,
    })
  }

  return (
    <>
      <div className='m-1 mt-2'>
        <div className='grid grid-cols-2 items-center'>
          <DatePicker
            isRequired={true}
            raytebValue={date}
            value={new Date(date).toShamsi()}
            innerText='تاریخ'
            id='ResultDate'
            className='h-9'
            onChange={handleToDateChange}
          />
          <div className='mr-3 mb-2'>
            <label className='text-secondary'>نمایش در پرونده</label>
            <input
              type='checkbox'
              className='m-1.5'
              checked={item?.isAbstract || false}
              onChange={() =>
                onItemChange({
                  ...item,
                  isAbstract: !item?.isAbstract!,
                  items: item?.items!,
                })
              }
            ></input>
          </div>
        </div>
        <div className='grid grid-cols-2 gap-4 mt-3'>
          {catalogs?.map((n, i) => (
            <TextBox
              className='ml-4'
              innerText={n.title}
              value={
                item?.items?.find((obj) => obj.laboratoryServeId === n.id)
                  ?.description || ''
              }
              key={i}
              Type={TextBoxTypeEnum.Text}
              debounceTime={0}
              // ={item?.items?.some((x) => x.LaboratoryServeId === n.id)}
              onChange={(e) => onChange(e, n)}
            />
          ))}
        </div>
      </div>
    </>
  )
}
export default RecordLaboratoryResult
